import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import {ReactComponent as BookBg} from 'src/assets/bookBg.svg';
import {useNavigate} from "react-router-dom";


const BookWrapper = css`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    .bookBg {
        position: absolute;
        width: 440px;
        height: 440px;
        z-index: 0;
        pointer-events: none;

        svg {
            width: 100%;
            height: 100%;
        }
    }

    .bookBg-top {
        top: -180px;
        left: -160px;
    }

    .bookBg-bottom {
        bottom: -120px;
        right: -150px;
    }
`;

const BookListWrapper = css`
    display: flex;
    flex-direction: column;
    min-width: 320px;
    width: 100%;
    align-items: center;
    /*min-height: 600px;*/
    position: relative;
    overflow: hidden;
    box-sizing: border-box;

    .bookCarouse {
        display: flex;
        flex-direction: row;
  
        width: 100%;
     /*    background-color: orange; */
        position: relative;
        min-height: 140px;
        z-index: 1;
        margin-top: 200px;
        

        .book {
            width: 219px;
            position: absolute;
            left: 50%;
            //box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            border-radius: 6px;
            border: 1px solid rgba(204, 204, 204, 0.6);
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
               border-radius: 6px;
                /* border: 1px solid rgba(204, 204, 204, 0.6);*/
            }
            transition: all 0.5s ease;
        }

        & .item-0 {
            width: 170px;
            height: 226px;
            z-index: 1;
            transform: translateX(-100%); /* 맨 왼쪽 */
            bottom: 50px;
            box-shadow: 0px 3.7px 5.6px 0px rgba(0, 0, 0, 0.1),
                        0px 9.4px 14px -2.7px rgba(0, 0, 0, 0.1);

            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
                background: rgba(0, 0, 0, 0.6); // 검정색 40% 투명도
            }
            
        }
        & .item-1 {
            width: 184px;
            height: 272px;
            z-index: 2;
            transform: translateX(-80%);
            bottom: 30px;
            box-shadow: 0px 3.6px 5.3px 0px rgba(0, 0, 0, 0.1),
                        0px 8.9px 13.3px -2.7px rgba(0, 0, 0, 0.1);

            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
                //background: rgba(0, 0, 0, 0.2); // 검정색 40% 투명도
            }
            
        }
        & .item-2 {
            width: 219px;
            height: 324px;
            z-index: 3;
            transform: translateX(-50%); /* 가운데 */
            bottom: 0;
            box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1),
                        0px 10px 15px -3px rgba(0, 0, 0, 0.1);
        }
        & .item-3 {
            width: 184px;
            height: 272px;
            z-index: 2;
            transform: translateX(-20%);
            bottom: 30px;
            box-shadow: 0px 3.6px 5.3px 0px rgba(0, 0, 0, 0.1),
                        0px 8.9px 13.3px -2.7px rgba(0, 0, 0, 0.1);


            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
               // background: rgba(0, 0, 0, 0.2); // 검정색 40% 투명도
            }
            
        }
        .item-4 {
            position: relative; // 부모 기준
            width: 170px;
            height: 226px;
            z-index: 1;
            transform: translateX(0%);
            bottom: 50px;
            box-shadow: 0px 3.7px 5.6px 0px rgba(0, 0, 0, 0.1),
                        0px 9.4px 14px -2.7px rgba(0, 0, 0, 0.1);
            
            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
                background: rgba(0, 0, 0, 0.6); // 검정색 40% 투명도
            }
        }

    }

    .bookCarouse .book {
        position: absolute; /* 이게 문제의 핵심 */
    }


    .bookDot {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        width: 150px;
        margin-top : 30px;
        /* background-color: white; */
        z-index: 1;

        .dot {
            border-radius: 50%;
            height: 8px;
            width: 8px;
            background-color: #c7bfbd;
        }

        & .now {
            background-color: #19cf7a;
        }
    }
`;

const NewBookMobile = ({
                           bookList,
                           currentIndex,
                           dot,
                           handleBookList,
                           handleBookDetail
                       }: {
    bookList: any[];
    currentIndex: number;
    dot: number;
    handleBookList: (idx: number) => void;
    handleBookDetail: (bookId: number) => void;
}) => {
    return (

        <>
            <div className={"flex flex-col gap-10"}>

                <div className={"flex flex-col gap-2"}>
                    <span className={"text-2xl text-main font-bold"}>#NEW</span>
                    <span className="text-xl text-black font-semibold">신규 등록 작품</span>
                </div>

                <div className="flex flex-col items-end gap-2">
                    <div className="">

                        {bookList[currentIndex] && (
                            <span
                                className="text-black text-3xl font-bold">
                                 {
                                     bookList[currentIndex].bookTitle.length > 10
                                         ? bookList[currentIndex].bookTitle.slice(0, 10) + '...'
                                         : bookList[currentIndex].bookTitle
                                 }


                            </span>
                        )}


                    </div>
                    <div id="title" className="">
                        {bookList[currentIndex] && (
                            <span
                                className="text-base text-[#696969]">{bookList[currentIndex].authorName}</span>
                        )}
                    </div>
                </div>


                <div id="bookList" className="flex justify-center w-full">

                    <div css={BookWrapper}>
                        <div className="bookBg bookBg-top">
                            <BookBg/>
                        </div>

                        {/* 배경 SVG - 오른쪽 아래 */}
                        <div className="bookBg bookBg-bottom">
                            <BookBg/>
                        </div>

                        <div css={BookListWrapper}>
                            <div className="bookCarouse">
                                {bookList.map((it: any, idx: number) => (
                                    <div
                                        className={`book item-${it.id}`}
                                        onClick={() => {
                                            if (it.id === 2) {
                                                handleBookDetail(it.bookId);
                                            } else {
                                                handleBookList(it.id);
                                            }
                                        }}
                                    >

                                        {it.coverImage ? <img src={`data:image/jpeg;base64,${it.coverImage}`} alt="책 이미지"/> : <img src={`${process.env.PUBLIC_URL}/img/book_4.jpg`} alt="책 이미지"/> }

                                    </div>
                                ))}
                            </div>
                            <div className="bookDot">
                                {bookList.map((it: any, idx: number) => (
                                    <div className={idx === dot ? "dot now" : "dot"}></div>
                                ))}
                            </div>
                        </div>
                    </div>


                </div>


            </div>



        </>

    );
};

export default NewBookMobile;
